module.exports = __webpack_public_path__ + "static/img/extend_img04.af757bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/extend_img04.png
// module id = 75Vo
// module chunks = 1